import { NavigateFunction } from 'react-router-dom'

export const setSuccessPayment = (result: any, navigate: NavigateFunction) => {
  navigate('/register', {
    state: { res: result },
  })
}
